import { render, staticRenderFns } from "./EnlacesInteres.vue?vue&type=template&id=452e5376&"
import script from "./EnlacesInteres.vue?vue&type=script&lang=js&"
export * from "./EnlacesInteres.vue?vue&type=script&lang=js&"
import style0 from "./EnlacesInteres.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports